import {
  FIELDS_TO_TRANSFORM,
  LINE_FIELDS_TO_TRANSFORM,
} from "services/sosInventoryService/processTemplate/schema";
import { transformFields } from "services/utility/afterGet";

export function afterGet(record) {
  const newRecord = transformFields(record, FIELDS_TO_TRANSFORM);

  newRecord.inputs = newRecord.inputs.map((line) =>
    transformFields(line, LINE_FIELDS_TO_TRANSFORM)
  );

  newRecord.outputs = newRecord.outputs.map((line) =>
    transformFields(line, LINE_FIELDS_TO_TRANSFORM)
  );

  return newRecord;
}
